"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_document__jpg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "f36bce35-a1d1-4d7a-8673-0d7dc0558afa",
    x1: 125.08,
    y1: 44.36,
    x2: 159.64,
    y2: 78.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "document-jpg-hi"), /*#__PURE__*/React.createElement("g", {
    id: "0f98fbfa-8f26-452f-92a8-ba7124f24c6c",
    "data-name": "document-jpg-hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a452ab3f-ad34-4503-a06b-b9ea50aa07bc",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c6f225fe-b72d-474f-9415-38a45ef7ed51",
    "data-name": "Bill_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a70b4053-afb2-4c65-a811-16f0805fe251",
    "data-name": "Report_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c5915194-7d12-45f1-a438-7815f7a5d89d",
    "data-name": "vodafone_store_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9a098692-9246-45d8-8be1-fc0f30775d8b",
    "data-name": "Broadband_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dac1209d-21bf-4e7c-b50c-7a19b5bec444",
    "data-name": "Business_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "09a69338-cadb-463a-8aa1-a0ce2daf6e54",
    "data-name": "Calendar_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d6d427d1-385f-4299-8e38-bf2439aa966a",
    "data-name": "Camera_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6005d58f-8c15-4f83-8cb8-f1026ebdd427",
    "data-name": "Data_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a93c5f5c-e1be-415d-a9cc-97a461b41c7b",
    "data-name": "Desktop_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2cbee30e-9690-4b69-a460-c311d9df4ef4",
    "data-name": "Document_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "de6c096e-34db-4528-ac7f-0425efcf1e79",
    "data-name": "Edit_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "256de277-78ae-4678-8d27-6f4c8df7d9ba",
    "data-name": "Enterprise_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "10f25050-adea-4981-a57e-fdc624eb3aa0",
    "data-name": "Call_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4d1e521e-8b0a-49f5-89ff-a9432c728b37",
    "data-name": "Location_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bafeb5c0-49a7-4c51-a487-ac133d00d476",
    "data-name": "Mail_new_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c7e19cdb-a09e-43c0-9ef1-c81d457d1459",
    "data-name": "Mail_unread_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "afaef7d5-59c1-45b6-9299-485bebedc87e",
    "data-name": "Mobile_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0d8f1100-9e68-4ab1-92e8-cebdfd567747",
    "data-name": "Network_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "60f1a495-bf6f-41c8-a767-d2f5f4790236",
    "data-name": "Reports_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4474e7d7-faa5-4da7-a0c7-7c447cc3b0a0",
    "data-name": "Roaming_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e184639a-b704-4fc6-9fe5-7c9440dc1d8a",
    "data-name": "Security_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "28706c71-bf43-4d2c-95fb-8d370cffdf1e",
    "data-name": "Sim_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f4893fe3-c848-4d82-a4e5-07a8ea7ccfcd",
    "data-name": "Tablet_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bf34dbee-7d92-45bd-8d6c-be30542a2d7c",
    "data-name": "Text_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "327680ce-3bbf-4343-beef-9f1774bd43fa",
    "data-name": "TV_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0175912f-ab06-414f-854c-e06ac3a8db57",
    "data-name": "Warning_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "94329960-b5c7-4b06-ae83-99233cc4f342",
    "data-name": "<Gruppe>"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40,44V160h0a16,16,0,0,0,16,16h80a16,16,0,0,0,16-16h0V56H128a16,16,0,0,1-16-16V16H56A16,16,0,0,0,40,32V44",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,56H128a16,16,0,0,1-16-16V16Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,54a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16h24l-2-2Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,56c-.53,0-1.05,0-1.57-.08l-.62-.09c-.3,0-.6-.08-.89-.14s-.53-.12-.79-.19l-.65-.17c-.3-.09-.6-.2-.9-.3l-.47-.17c-.33-.13-.65-.28-1-.43l-.32-.16c-.35-.17-.68-.36-1-.56l-.2-.12q-.54-.33-1-.7l-.09-.07c-.36-.27-.71-.55-1-.84h0L152,86.56V56Z",
    transform: "translate(0 0)",
    opacity: 0.2,
    fill: "url(#f36bce35-a1d1-4d7a-8673-0d7dc0558afa)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,174H56a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16h80a16,16,0,0,0,16-16v-2A16,16,0,0,1,136,174Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5,125.58a2.73,2.73,0,0,1-2.3-1,3.45,3.45,0,0,1-.77-2.17,3.52,3.52,0,0,1,.77-2.21,2.73,2.73,0,0,1,2.3-1,2.67,2.67,0,0,1,2.28,1,3.59,3.59,0,0,1,.75,2.21,3.52,3.52,0,0,1-.75,2.17A2.67,2.67,0,0,1,57.5,125.58Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6,125.72a12,12,0,0,1-4.08-.63A15.07,15.07,0,0,1,63,124l1.62-4.69a4.52,4.52,0,0,0,1.82,1,7.74,7.74,0,0,0,2.52.46,3.62,3.62,0,0,0,2.43-.77,3.73,3.73,0,0,0,.9-2.92V95.87h5.61v21.21q0,4.38-2.13,6.51A8.34,8.34,0,0,1,69.6,125.72Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.93,125.1V95.87H92.7a25,25,0,0,1,3.9.28,11.89,11.89,0,0,1,3.46,1.12,6.68,6.68,0,0,1,3.11,3.13,10.08,10.08,0,0,1,1,4.45,10.75,10.75,0,0,1-.75,4,8.72,8.72,0,0,1-1.86,3,7.74,7.74,0,0,1-2.3,1.64,13.44,13.44,0,0,1-3,.85,18.86,18.86,0,0,1-3,.24H89.45V125.1Zm5.52-15.56h3.11a16.45,16.45,0,0,0,2.17-.13,5.34,5.34,0,0,0,1.69-.48,3.61,3.61,0,0,0,1.71-1.58,4.67,4.67,0,0,0-.07-4.43,3.26,3.26,0,0,0-1.78-1.49,10.79,10.79,0,0,0-3.51-.53H89.45Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.61,125.72a13.34,13.34,0,0,1-5.24-1,11.13,11.13,0,0,1-4.1-3,13.75,13.75,0,0,1-2.65-4.75,20,20,0,0,1-.94-6.4,20.61,20.61,0,0,1,1-6.82A14,14,0,0,1,110.4,99a10.8,10.8,0,0,1,3.92-2.83,13.28,13.28,0,0,1,10.85.5,9.62,9.62,0,0,1,3.64,3.66L125,103.89a7.26,7.26,0,0,0-1.4-1.77,6.22,6.22,0,0,0-2.06-1.23,7,7,0,0,0-2.45-.46,5.42,5.42,0,0,0-3.64,1.4,7.75,7.75,0,0,0-2.32,3.79,17.57,17.57,0,0,0-.7,5,13.34,13.34,0,0,0,1.18,5.81,6.46,6.46,0,0,0,2.94,3.29,8.1,8.1,0,0,0,3.42.81,16.23,16.23,0,0,0,2.83-.2A7.72,7.72,0,0,0,124,120v-5.26h-4.56v-5h9.82v14.07a12.68,12.68,0,0,1-3.59,1.32A25.71,25.71,0,0,1,119.61,125.72Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  })))))))))))))))))))))))))))))));
}

var _default = ic_document__jpg;
exports.default = _default;